import React from 'react';
import { useTranslation } from 'react-i18next';
import Headline from '../UI/Headline/Headline';
import visaImg from '../../assets/images/visa.png';
import mastercardImg from '../../assets/images/mastercard.png';
import cashImg from '../../assets/images/cash.png';
import mapImg from '../../assets/images/map.png';
import classes from './PaymentMethodsSection.module.scss';

const PaymentMethodsSection = () => {
  const { t } = useTranslation();

  const methods = [
    { src: visaImg, alt: 'Visa' },
    { src: mastercardImg, alt: 'Mastercard' },
    { src: cashImg, alt: 'Cash' },
    { src: mapImg, alt: 'Partner stores on map' }
  ];

  return (
    <section className={classes.section}>
      <Headline>{t('pages.main.paymentMethods.title')}</Headline>
      <h4 style={{ marginBottom: 40, marginTop: 60 }}>
        {t('pages.main.paymentMethods.text')}
      </h4>
      <div className={classes.list}>
        {methods.map((m) => (
          <img key={m.alt} className={classes.logo} src={m.src} alt={m.alt} />
        ))}
      </div>
    </section>
  );
};

export default PaymentMethodsSection;
